var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-error',{attrs:{"title":"500","message":_vm.message,"error":_vm.error}})}
var staticRenderFns = []

export { render, staticRenderFns }